import { FormValues, PagedResultEffectWithTotals } from "../types";
import { bffApi } from "../../../services/bff/bffApi";
import { getErrorMessage } from "../../../utils/getErrorMessage";
import {BaseService} from "../../../global/classes";

export default class ContractEffectsService extends BaseService {
  getContracts = async (
    page: number,
    pageSize: number,
    filter?: FormValues
  ): Promise<PagedResultEffectWithTotals> => {
    const initialDate = filter?.initialDate || null;
    const finalDate = filter?.finalDate || null;
    const merchantId = filter?.merchantId || this.selectedCompany?.merchantId || null;
    const document = filter?.document || null;
    const commercialHierId = this.userInfo?.commercialHierId || null;

    try {
      const response = await bffApi.get(
        `/api/reg/v2/restrictionsinfo/contract-effect-details`,
        {
          params: {
            page: page,
            pageSize: pageSize,
            settlementStart: initialDate,
            settlementEnd: finalDate,
            merchantId: merchantId,
            documentFinalUser: document,
            commercialHierId: commercialHierId,
          },
        }
      );

      return response.data as PagedResultEffectWithTotals;
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      console.log(errorMessage);
      throw error;
    }
  };

  async getContractEffectPayment(hashIdentifier: string) {
    try {
      const response = await bffApi.get(
        `/api/reg/v2/restrictionsinfo/contract-effect-payments/${hashIdentifier}`
      );

      return response.data;
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      console.log(errorMessage);
    }
  }

  async getContractEffectHistory(hashIdentifier: string) {
    try {
      const response = await bffApi.get(
        `/api/reg/v2/restrictionsinfo/contract-effect-history/${hashIdentifier}`
      );

      return response.data;
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      console.log(errorMessage);
    }
  }

  async markAsPaid(selectedRows: string[], settlementDate: string) {
    try {
      const isoDate = new Date(settlementDate).toISOString();

      const response = await bffApi.post(`/api/reg/v1/cerc/settle-contract-effects`,
        {
          SelectedRows: selectedRows,
          SettlementDate: isoDate
        }
      );

      return response;
    } catch (error) {
      console.error("Erro ao obter token:", error);
      throw error;
    }
  }
}
